<template>
  <div :class="`card text-white bg-gradient-${color}`">
    <div class="card-body">
      <div class="card-info">
        <h2 class="text-uppercase font-weight-bold mb-0">
          {{ info.subLabel }}
          <span
            v-if="info.extraInfo"
            class="text-muted text-lowercase"
            style="font-size: 10px"
          >
            {{ info.extraInfo }}
          </span>
        </h2>

        <div class="card-label mb-0">
          <span class="divider">/</span> {{ info.label }}
        </div>
      </div>

      <div
        v-if="info.image"
        class="card-image"
      >
        <img
          :src="info.image"
          alt="Imagem do card"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      required: true
    },

    color: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border: 0;

  .card-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .card-info {
    display: flex;
    align-items: center;
  }

  .card-label {
    font-weight: 500;
    font-size: 14px;
    padding-left: 5px;
    padding-top: 3px;
  }

  .card-image {
    max-width: 40px;
    max-height: 40px;

    img {
      width: 100%;
    }
  }
}

@media only screen and (max-width: 992px) {
  .card {
    .card-info {
      flex-direction: column;
      align-items: flex-start;

      .divider {
        display: none;
      }
    }

    .card-label {
      padding-left: 0px;
    }

    .card-image {
      max-width: 32px;
      max-height: 32px;
    }
  }
}
</style>
